var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React from 'react';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { withContext, withRouter } from "../componentWrappers";
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import { Loader } from "../components/Elements/Loader";
import * as uiActions from "../Entities/actions/uiActions";

import { store } from "../store";
import { setDocuments, unsetDocuments } from "../Library/actions/libraryActions";
import { processQuery } from "../Library/helpers/requestState";
import { wrapDispatch } from "../Multireducer";
import * as relationships from "../Relationships/utils/routeUtils";
import relationTypesAPI from "../RelationTypes/RelationTypesAPI";
import * as reviewActions from "./actions/actions";
import { OneUpEntityViewer } from "./components/OneUpEntityViewer";
import api from "../Search/SearchAPI";
import TemplatesAPI from "../Templates/TemplatesAPI";
import ThesauriAPI from "../Thesauri/ThesauriAPI";

import { setReferences } from "../Viewer/actions/referencesActions";
import { propertyTypes } from "../../shared/propertyTypes";












function buildInitialOneUpState(
documentsRequest,
numDocuments,
thesauri,
templates)
{var _documentsRequest$dat, _documentsRequest$dat2;
  const thesaurusValues = [];
  const thesauriKeys = Object.keys((_documentsRequest$dat = (_documentsRequest$dat2 = documentsRequest.data) === null || _documentsRequest$dat2 === void 0 ? void 0 : _documentsRequest$dat2.filters) !== null && _documentsRequest$dat !== void 0 ? _documentsRequest$dat : {}).reduce((res, k) => {
    const propName = k.startsWith('__') ? k.substring(2) : k;
    if (k.startsWith('__')) {
      thesaurusValues.push(
        ...documentsRequest.data.filters[k].values.filter(
          (v) => v && !['any', 'missing'].includes(v)
        )
      );
    }
    return _objectSpread(_objectSpread({},
    res),
    templates.reduce((res2, tmpl) => {
      const prop = (tmpl.properties || []).find((p) => p.name === propName);
      if (
      !prop ||
      !prop.content ||
      prop.type !== propertyTypes.select && prop.type !== propertyTypes.multiselect)
      {
        return res2;
      }
      return _objectSpread(_objectSpread({}, res2), {}, { [prop.content]: true });
    }, {}));

  }, {});
  const thesaurus =
  Object.keys(thesauriKeys).length === 1 ?
  thesauri.find((t) => t._id.toString() === Object.keys(thesauriKeys)[0]) :
  null;
  thesauri.forEach((t) => {
    (t.values || []).forEach((tv) => {
      const i = thesaurusValues.findIndex((v) => v === tv.id);
      if (i >= 0) {
        thesaurusValues[i] = tv.label;
      }
    });
  });
  return {
    loaded: true,
    fullEdit: false,
    loadConnections: false,
    indexInDocs: 0,
    totalDocs: numDocuments,
    maxTotalDocs: 5001,
    requestHeaders: documentsRequest.headers,
    reviewThesaurusName: thesaurus ? thesaurus.name : '',
    reviewThesaurusId: thesaurus ? thesaurus._id.toString() : '',
    reviewThesaurusValues: thesaurusValues
  };
}

class OneUpReviewBase extends RouteHandler {
  static async requestState(requestParams, state) {
    const documentsRequest = requestParams.set(_objectSpread(_objectSpread({},
    processQuery(requestParams.data, state)), {}, {
      limit: 5001,
      select: ['sharedId'],
      unpublished: !!requestParams.data.unpublished,
      includeUnpublished: !!requestParams.data.includeUnpublished,
      includeReviewAggregations: true })
    );

    const [templates, thesauri, relationTypes, documents] = await Promise.all([
    TemplatesAPI.get(requestParams.onlyHeaders()),
    ThesauriAPI.getThesauri(requestParams.onlyHeaders()),
    relationTypesAPI.get(requestParams.onlyHeaders()),
    api.search(documentsRequest)]
    );

    const firstSharedId = documents.rows.length ? documents.rows[0].sharedId : '';

    return [
    actions.set('relationTypes', relationTypes),
    (dispatch) => wrapDispatch(dispatch, 'library')(unsetDocuments()),
    (dispatch) => wrapDispatch(dispatch, 'library')(setDocuments(documents)),
    actions.set(
      'oneUpReview.state',
      buildInitialOneUpState(documentsRequest, documents.rows.length, thesauri, templates)
    ),
    ...(firstSharedId ?
    await reviewActions.getAndLoadEntity(
      requestParams.set({ sharedId: firstSharedId }),
      templates,
      state,
      false
    ) :
    [])];

  }

  urlHasChanged(nextProps) {
    const nextSearchParams = new URLSearchParams(nextProps.location.search);
    const currentSearchParams = new URLSearchParams(this.props.location.search);
    return nextSearchParams.get('q') !== currentSearchParams.get('q');
  }

  componentWillUnmount() {
    this.emptyState();
  }

  componentDidMount() {
    store === null || store === void 0 ? void 0 : store.dispatch(uiActions.showTab('info'));
  }

  emptyState() {
    wrapDispatch(store === null || store === void 0 ? void 0 : store.dispatch, 'library')(unsetDocuments());
    store === null || store === void 0 ? void 0 : store.dispatch(setReferences([]));
    store === null || store === void 0 ? void 0 : store.dispatch(actions.unset('entityView/entity'));
    store === null || store === void 0 ? void 0 : store.dispatch(formActions.reset('entityView.entityForm'));
    store === null || store === void 0 ? void 0 : store.dispatch(relationships.emptyState());
    actions.set('oneUpReview.state', {});
  }

  render() {
    const { entity, oneUpState } = this.props;
    if (
    !oneUpState ||
    !oneUpState.get('loaded') ||
    oneUpState.get('totalDocs') && (!entity || !entity.get('_id')))
    {
      return /*#__PURE__*/_jsx(Loader, {});
    }
    return /*#__PURE__*/_jsx(OneUpEntityViewer, { mainContext: this.props.mainContext });
  }
}










const mapStateToProps = (state) => (
{
  entity: state.entityView.entity,
  oneUpState: state.oneUpReview.state
});


export { OneUpReviewBase };
//@ts-ignore
export default connect(mapStateToProps)(withRouter(withContext(OneUpReviewBase)));